import { RejectionTreatmentType } from "@nkr/enums/rejection-treatment-type"

export interface IRejectionTreatment {
    id: number,
    recipientId: number,
    treatmentType: RejectionTreatmentType,
    otherDetails: string
}